import { Component } from '@angular/core';

@Component({
  selector: 'app-condizioni-vendita',
  templateUrl: './condizioni-vendita.component.html',
  styleUrl: './condizioni-vendita.component.css'
})
export class CondizioniVenditaComponent {

}
